// #region RULES
/** Password rules shown as a checklist (and enforced by the account service). */
export const RULES: [string, (p: string) => boolean][] = [
    ['8+ characters', (p) => p.length >= 8], ['A lowercase letter', (p) => /[a-z]/.test(p)], ['An uppercase letter', (p) => /[A-Z]/.test(p)],
    ['A number', (p) => /\d/.test(p)], ['A symbol', (p) => /[^A-Za-z0-9]/.test(p)]
];
